module.exports = __webpack_public_path__ + "static/Priyabrata-Kuanr-932511c5f037edcb3719937b5fbdce69.png";